// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"3809999d","453":"1eaf32e7"}[chunkId] + ".chunk.js";
};